import {ModuleMember} from "@/lib/store/modules/metadata/ModuleMember";
import {BaseModule} from "@/lib/store/modules/BaseModule";

export class Action extends ModuleMember {
    public toVuex(module: BaseModule) {
        const key = this.key;
        return function (ctx, payload) {
            return module[key](payload, ctx);
        }
    }
}
